var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
const StyledBox = styled(Box) `
  && {
    font-size: 14px;
    line-height: 15px;
    letter-spacing: 0;
  }
`;
export const TabPanel = (props) => {
    const { children, value, currentTab, width, paddingY } = props, other = __rest(props, ["children", "value", "currentTab", "width", "paddingY"]);
    return (_jsx(Typography, Object.assign({ component: 'div', role: "tabpanel", hidden: currentTab !== value, id: `tabpanel-${value}`, "aria-labelledby": `tab-${value}` }, other, { children: value === currentTab && (_jsx(StyledBox, Object.assign({ paddingY: paddingY !== null && paddingY !== void 0 ? paddingY : 2, style: { width: `${width}` } }, { children: children }))) })));
};
